import { useTranslation } from 'react-i18next';
import { AlertBanner } from 'components/AlertBanner';
import { Link } from 'components/Link';
import { useUser } from 'services/User';
import { isInOrganization } from 'services/accessControl';
import { getExpiredLicenseStatus } from 'utils/license';

export const ExpiredLicenseBanner = () => {
    const { t } = useTranslation();
    const { user } = useUser();

    if (!getExpiredLicenseStatus(user)) {
        return null;
    }

    const isOrgAccount = isInOrganization(user);

    const message = (
        <div>
            {isOrgAccount
                ? t("Your organization's MetaDefender Cloud license has expired. See ")
                : t('Your MetaDefender Cloud license has expired. See ')}
            <Link to='/licensing'>{t('Licensing')}</Link>
            {t(' to renew.')}
        </div>
    );

    return <AlertBanner variant='error' text={message} className='tw:mb-12' />;
};
